import React, { useState } from 'react';
import { Table, Tag, Space, Button, Card, Input, Select } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { Option } = Select;

const EmulatorManagement = () => {
  const [loading, setLoading] = useState(false);

  // Mock data for emulator instances
  const data = [
    {
      key: '1',
      instanceId: 'emu-001',
      node: 'node-01 (192.168.1.101)',
      status: 'Running',
      cpuUsage: '45%',
      memUsage: '2.1GB / 4GB',
      deviceProfile: 'Pixel 6 Pro', // New column data
      uptime: '2d 4h',
    },
    {
      key: '2',
      instanceId: 'emu-002',
      node: 'node-02 (192.168.1.102)',
      status: 'Starting',
      cpuUsage: '10%',
      memUsage: '0.5GB / 4GB',
      deviceProfile: 'Samsung S21', // New column data
      uptime: '0h 1m',
    },
    {
      key: '3',
      instanceId: 'emu-003',
      node: 'node-01 (192.168.1.101)',
      status: 'Idle',
      cpuUsage: '5%',
      memUsage: '1.2GB / 4GB',
      deviceProfile: 'Default/AOSP', // New column data
      uptime: '5d 12h',
    },
  ];

  const columns = [
    {
      title: 'Instance ID',
      dataIndex: 'instanceId',
      key: 'instanceId',
      render: (text: string) => <a>{text}</a>,
    },
    {
      title: 'Node',
      dataIndex: 'node',
      key: 'node',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        let color = 'default';
        if (status === 'Running') color = 'success';
        if (status === 'Starting') color = 'processing';
        if (status === 'Error') color = 'error';
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: 'Device Profile', // New Column
      dataIndex: 'deviceProfile',
      key: 'deviceProfile',
      render: (profile: string) => (
        <Tag color="blue">{profile}</Tag>
      ),
    },
    {
      title: 'CPU Usage',
      dataIndex: 'cpuUsage',
      key: 'cpuUsage',
    },
    {
      title: 'Memory Usage',
      dataIndex: 'memUsage',
      key: 'memUsage',
    },
    {
      title: 'Uptime',
      dataIndex: 'uptime',
      key: 'uptime',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" size="small">Logs</Button>
          <Button type="link" size="small" danger>Stop</Button>
        </Space>
      ),
    },
  ];

  return (
    <Card 
      title="Emulator Instances" 
      extra={
        <Space>
          <Input placeholder="Search Instance ID" prefix={<SearchOutlined />} style={{ width: 200 }} />
          <Select defaultValue="all" style={{ width: 120 }}>
            <Option value="all">All Status</Option>
            <Option value="running">Running</Option>
            <Option value="stopped">Stopped</Option>
          </Select>
          <Button icon={<ReloadOutlined />} onClick={() => setLoading(true)}>Refresh</Button>
        </Space>
      }
    >
      <Table 
        columns={columns} 
        dataSource={data} 
        loading={loading}
      />
    </Card>
  );
};

export default EmulatorManagement;
